import { html } from "lit";
var icon_performanceReporting_default = () => html`
  <svg stroke-fill xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path
        stroke-width="2"
        d="M8.38 11.804a1.565 1.565 0 103.132.002 1.565 1.565 0 00-3.133-.002zm3.131 0h9.326m-17.087 0h4.63m4.695 7.011a1.564 1.564 0 103.128.002 1.564 1.564 0 00-3.128-.002zm.001 0H3.75m17.087 0h-4.63m-3.132-14.25a1.564 1.564 0 103.128.002 1.564 1.564 0 00-3.128-.002zm.001 0H3.75m17.087 0h-4.63" />
    </g>
  </svg>
`;
export {
  icon_performanceReporting_default as default
};
//# sourceMappingURL=icon-performanceReporting.js.map
